import { render } from "./BaseRouter.vue?vue&type=template&id=28d23541&ts=true&lang=true"
import script from "./BaseRouter.vue?vue&type=script&lang=ts"
export * from "./BaseRouter.vue?vue&type=script&lang=ts"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__